import { colors } from '@lmc/common/constants'
import type { HomeSource } from '@lmc/ts-common'
import type * as React from 'react'
import Text from '../../atoms/Text'
import type IconType from '../../general/Icon/iconTypes'
import HeroCard from '../HeroCard'
import IconLinkList, { type ItemType } from '../IconLinkList'
import VideoCard from '../VideoCard'
import style from './index.module.less'

export type PaywallTemplateProps = {
  backgroundColor: string
  backgroundImage?: string
  title: string
  subTitle: string
  bodyText: string
  cta: string
  onClick: () => void
  icon:
    | IconType.CarePlansHexagon
    | IconType.DocsHexagon
    | IconType.EmarHexagon
    | IconType.FamilyHexagon
    | IconType.GroupsHexagon
    | IconType.ProHexagon
    | IconType.HandoversHexagon
    | IconType.ConsentHexagon
  videoUrl: string
  articles: Array<ItemType>
  leftModuleCard: React.ReactElement
  rightModuleCard: React.ReactElement
  ctaDisabled?: boolean
  disabledText?: string | React.ReactElement
  findOutMoreURL: string
  source?: HomeSource
  customLinkText?: string
  testId?: string
}

const PaywallTemplate: React.FC<PaywallTemplateProps> = ({
  backgroundColor = colors.white,
  backgroundImage = 'https://lmc-data-production.s3.eu-west-2.amazonaws.com/icons/paywall/HeroBackground.png',
  bodyText,
  cta,
  icon,
  onClick,
  subTitle,
  title,
  videoUrl,
  articles,
  leftModuleCard,
  rightModuleCard,
  ctaDisabled = false,
  disabledText,
  findOutMoreURL,
  source,
  customLinkText,
  testId
}) => (
  <div className={style.wrapper} data-testid={testId}>
    <div className={style.heroContainer}>
      <HeroCard
        backgroundColor={backgroundColor}
        backgroundImage={backgroundImage}
        title={title}
        subTitle={subTitle}
        bodyText={bodyText}
        cta={cta}
        onClick={onClick}
        icon={icon}
        ctaDisabled={ctaDisabled}
        disabledText={disabledText}
        findOutMoreURL={findOutMoreURL}
        source={source}
        customLinkText={customLinkText}
      />
    </div>
    <div className={style.secondRowContainer}>
      <div className={style.secondRowCol}>
        <div className={style.iconLinkListWrapper}>
          <IconLinkList items={articles} />
        </div>
      </div>
      <div className={style.secondRowCol}>
        <VideoCard className={style.videoCard} url={videoUrl} />
      </div>
    </div>
    <div className={style.secondaryTextWrapper}>
      <Text
        as="h2"
        style={{
          fontWeight: 500,
          whiteSpace: 'nowrap'
        }}
      >
        Other features and add-ons
      </Text>
      <div
        style={{
          borderTop: '1px solid #D9D9D9',
          display: 'block',
          width: '100%',
          marginBottom: '15px',
          marginLeft: '5px'
        }}
      />
    </div>
    <div className={style.additionalModulesContainer}>
      <div className={style.modulesWrapper}>{leftModuleCard}</div>
      <div className={style.modulesWrapper}>{rightModuleCard}</div>
    </div>
    <div className={style.bottomTextWrapper}>
      <Text as="p2">
        *Price based on no. of residents added to your current plan
      </Text>
    </div>
  </div>
)

export default PaywallTemplate
